module.exports = __webpack_public_path__ + "media/images/logo-f798633732058a8298754f48f3ddd121.svg";